module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_1@2x.11fb576.webp";